export default {
  en: {
    service_model_name: "{0} Service Model",
  },
  es : {
    service_model_name: "Modelo de Servicio {0}",
  },
  ca : {
    service_model_name: "Model de Servei {0}",
  }
};
